module.exports = __webpack_public_path__ + "static/media/19.28eb60ad.mp3";